import { digit } from "./digit"
import { system } from "./system"
import { member } from "./member"
import { life } from "./life"
import { supervise } from "./supervise"
import { affluent } from './affluent'
import { operate } from './operate'
import { memberCenter } from "./memberCenter"
export const adminRouterAll = [
    {
        path: '/user',
        name: '控制台',
        redirect: 'home',
        component: () => import("@/views/layout/index.vue"),
        isShow:false,
        children: [
            {
                path: 'home',
                component: () => import("@/views/admin/home/index.vue"),
                name: '控制台',
                meta: {
                    hidden: true,
                    user: 0,
                },
            },
            {
                path: 'overview',
                component: () => import("@/views/admin/life/agrotechnical/overview/index.vue"),
                name: '控制台',
                meta: {
                    hidden: true,
                    user: 0,
                },
            },
        ]
    },
    ...digit,
    ...system,
    ...member,
    ...life,
    ...supervise,
    ...affluent,
    ...operate,
    ...memberCenter,
]